export type EntryIdentity = 'founder' | 'scroller';

export function isIdentityEntry(search: string) {
  const params = new URLSearchParams(search);
  return ['fc1', 'tst1'].includes(params.get('qz') ?? '');
}

export function normalizeEntryIdentity(value: unknown): EntryIdentity | undefined {
  return value === 'founder' || value === 'scroller' ? value : undefined;
}

export function getIdentityPitch(identity: EntryIdentity | undefined) {
  return identity === 'founder' ? 'Founder mode confirmed. Let’s protect it.'
    : identity === 'scroller' ? 'Alright, recovering Scroller. Let’s fix that.' : null;
}
